var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"condizioni-generali"},[_c('div',{staticClass:"default-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('pageNotFound.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('pageNotFound.content')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }